import React, { useState } from "react";

// components
import CardProjectTable from "components/Cards/CardProjectTable.js";
import CardProjectForm from "components/Cards/CardProjectForm.js";
import { useAuth } from "contexts/AuthContext";

export default function Projects() {
  const { refreshUser } = useAuth();
  const [selectedProject, setSelectedProject] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEditProject = (project) => {
    setSelectedProject(project);
    setIsFormOpen(true);
  };

  const handleNewProject = () => {
    setSelectedProject(null);
    setIsFormOpen(true);
  };

  const handleFormSave = (result) => {
    setIsFormOpen(false);
    setSelectedProject(null);
    // Trigger refresh of table
    setRefreshTrigger(prev => prev + 1);
    // Refresh user data to update plan limits
    refreshUser();
  };

  const handleFormCancel = () => {
    setIsFormOpen(false);
    setSelectedProject(null);
  };

  const handleProjectDeleted = (projectId) => {
    // Trigger refresh of table
    setRefreshTrigger(prev => prev + 1);
    // Refresh user data to update plan limits
    refreshUser();
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        {/* Main Project Table */}
        <div className="w-full mb-12 px-4">
          <CardProjectTable 
            key={refreshTrigger}
            onEditProject={handleEditProject}
            onDeleteProject={handleProjectDeleted}
            onNewProject={handleNewProject}
          />
        </div>
      </div>

      {/* Project Form Modal */}
      <CardProjectForm
        project={selectedProject}
        isOpen={isFormOpen}
        onSave={handleFormSave}
        onCancel={handleFormCancel}
      />
    </>
  );
}